import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=b28eedf4&scoped=true&"
import script from "./Account.vue?vue&type=script&lang=ts&"
export * from "./Account.vue?vue&type=script&lang=ts&"
import style0 from "./Account.vue?vue&type=style&index=0&id=b28eedf4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28eedf4",
  null
  
)

export default component.exports